import { render, staticRenderFns } from "./BrowseAssessments.vue?vue&type=template&id=43d2daaa&scoped=true"
import script from "./BrowseAssessments.vue?vue&type=script&lang=js"
export * from "./BrowseAssessments.vue?vue&type=script&lang=js"
import style0 from "./BrowseAssessments.vue?vue&type=style&index=0&id=43d2daaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d2daaa",
  null
  
)

export default component.exports